import { t } from "i18next";
import useWhiteLabel from "whitelabel/useWhiteLabel";

const Footer = () => {
  const { links } = useWhiteLabel();
  return (
    <div className="flex w-full flex-col items-center justify-between bg-opacity-20 px-1 lg:flex-row lg:px-12">
      <p className="text-center text-txt-sm">
        <span className="mb-2 text-center text-txt-sm text-secondary">
          ©{new Date().getFullYear()} {t("footer.all.rights")}
        </span>
      </p>
      <div>
        <ul className="flex flex-wrap items-center justify-center gap-3 sm:flex-nowrap md:gap-10">
          <li>
            <a
              target="blank"
              href={links.support}
              className="text-txt-sm text-secondary"
            >
              {t("footer.support")}
            </a>
          </li>
          <li>
            <a
              target="blank"
              href={links.privacyPolicy}
              className="text-txt-sm text-secondary"
            >
              {t("footer.privacy.policy")}
            </a>
          </li>
          <li>
            <a
              target="blank"
              href={links.terms}
              className="text-txt-sm text-secondary"
            >
              {t("footer.terms.use")}
            </a>
          </li>
          <li>
            <a
              target="blank"
              href={links.contact}
              className="text-txt-sm text-secondary"
            >
              {t("footer.contact.us")}
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;
